import { auth, dashboard, checkIsApproveCompany } from '@/middleware';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/dashboard',

    component: () => import('@/layouts/DashboardLayout.vue'),
    beforeEnter: [auth, dashboard, checkIsApproveCompany],
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('@/pages/dashboard/PsclHome.vue'),
        meta: {
          title: 'Pscl Home',
          navbar: true,
        },
      },
      {
        path: 'company/:company',
        // name: 'dashboard.company',
        component: () => import('@/pages/dashboard/PSCLCompanyPage.vue'),
        meta: {
          title: 'Pscl Company',
          navbar: false,
        },
      },
      {
        path: 'benchmarking',
        name: 'dashboard.benchmarking',
        component: () => import('@/pages/dashboard/BenchmarkingPage.vue'),
        meta: {
          title: 'Benchmarking',
          navbar: true,
        },
      },
      {
        path: 'measures',
        name: 'dashboard.measures',
        component: () => import('@/pages/dashboard/MeasuresPage.vue'),
        meta: {
          title: 'Measurements',
          navbar: true,
        },
      },
      {
        path: 'map',
        name: 'dashboard.map',
        component: () => import('@/pages/dashboard/MapPage.vue'),
        meta: {
          title: 'Map',
          navbar: true,
        },
      },
      {
        path: 'suggestions',
        name: 'dashboard.suggestions',
        component: () => import('@/pages/CompanyForm/CompanySuggestions.vue'),
        meta: {
          title: 'Suggestions',
          navbar: true,
        },
      },
    ],
  },
];

export default routes;
